import { AppRouter } from "./router/AppRouter";

export const PdfApp = () => {
  return (
    <AppRouter />
  );
};
